export const step1ChpList = {
  // # Biochemistry topics
  biochemistry: [
    {
      id: "molecular_biology",
      name: "Molecular Biology",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_MOLECULAR_BIOLOGY,
    },
    {
      id: "cellular_biology",
      name: "Cellular Biology",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_CELLULAR_BIOLOGY,
    },
    {
      id: "laboratory_techniques",
      name: "Laboratory Techniques",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_LABORATORY_TECHNIQUES,
    },
    {
      id: "genetics",
      name: "Genetics",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_GENETICS,
    },
    {
      id: "nutrition",
      name: "Nutrition",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_NUTRITION,
    },
    {
      id: "metabolism",
      name: "Metabolism",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_METABOLISM,
    },
    {
      id: "protein",
      name: "Protein",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_PROTEIN,
    },
    {
      id: "lipids",
      name: "Lipids",
      url: process.env.REACT_APP_STEP1_BIOCHEMISTRY_LIPIDS,
    },
    {
      id: "signal_transduction_pathways",
      name: "Signal Transduction Pathways",
      url: process.env
        .REACT_APP_STEP1_BIOCHEMISTRY_SIGNAL_TRANSDUCTION_PATHWAYS,
    },
  ],

  // # Immunology topics
  immunology: [
    {
      id: "lymphoid_structures",
      name: "Lymphoid Structures",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_LYMPHOID_STRUCTURES,
    },
    {
      id: "innate_immunity",
      name: "Innate Immunity",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_INNATE_IMMUNITY,
    },
    {
      id: "adaptive_immunity",
      name: "Adaptive Immunity",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_ADAPTIVE_IMMUNITY,
    },
    {
      id: "cytokine_and_cell_surface_proteins",
      name: "Cytokines & Cell Surface Proteins",
      url: process.env
        .REACT_APP_STEP1_IMMUNOLOGY_CYTOKINE_AND_CELL_SURFACE_PROTEINS,
    },
    {
      id: "vaccination",
      name: "Vaccination",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_VACCINATION,
    },
    {
      id: "hypersensitivity_blood_transfusion_reactions",
      name: "Hypersensitivity & Blood Transfusion",
      url: process.env
        .REACT_APP_STEP1_IMMUNOLOGY_HYPERSENSITIVITY_BLOOD_TRANSFUSION_REACTIONS,
    },
    {
      id: "immunodeficiencies",
      name: "Immunodeficiencies",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_IMMUNODEFICIENCIES,
    },
    {
      id: "transplant_rejection",
      name: "Transplant Rejection",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_TRANSPLANT_REJECTION,
    },
    {
      id: "autoimmune_and_vasculitis",
      name: "Autoimmune & Vasculitis",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_AUTOIMMUNE_AND_VASCULITIS,
    },
    {
      id: "immunologic_drugs",
      name: "Immunologic Drugs",
      url: process.env.REACT_APP_STEP1_IMMUNOLOGY_IMMUNOLOGIC_DRUGS,
    },
  ],

  // # Pharmacology topics
  pharmacology: [
    {
      id: "pharmacokinetics",
      name: "Pharmacokinetics",
      url: process.env.REACT_APP_STEP1_PHARMACOLOGY_PHARMACOKINETICS,
    },
    {
      id: "pharmacodynamics",
      name: "Pharmacodynamics",
      url: process.env.REACT_APP_STEP1_PHARMACOLOGY_PHARMACODYNAMICS,
    },
    {
      id: "autonomic_drugs",
      name: "Autonomic Drugs",
      url: process.env.REACT_APP_STEP1_PHARMACOLOGY_AUTONOMIC_DRUGS,
    },
    {
      id: "toxicities_and_adverse_effects",
      name: "Toxicities & Adverse Effects",
      url: process.env
        .REACT_APP_STEP1_PHARMACOLOGY_TOXICITIES_AND_ADVERSE_EFFECTS,
    },
  ],

  // # Endocrine topics
  endocrine: [
    {
      id: "thyroid_embryology_and_anatomy",
      name: "Thyroid - Embryology and Anatomy",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_THYROID_EMBRYOLOGY_AND_ANATOMY,
    },
    {
      id: "thyroid_physiology",
      name: "Thyroid - Physiology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_THYROID_PHYSIOLOGY,
    },
    {
      id: "thyroid_pathology",
      name: "Thyroid - Pathology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_THYROID_PATHOLOGY,
    },
    {
      id: "thyroid_pharmacology",
      name: "Thyroid - Pharmacology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_THYROID_PHARMACOLOGY,
    },
    {
      id: "pituitary_embryology_and_anatomy",
      name: "Pituitary - Embryology and Anatomy",
      url: process.env
        .REACT_APP_STEP1_ENDOCRINE_PITUITARY_EMBRYOLOGY_AND_ANATOMY,
    },
    {
      id: "pituitary_physiology",
      name: "Pituitary - Physiology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_PITUITARY_PHYSIOLOGY,
    },
    {
      id: "pituitary_pathology",
      name: "Pituitary - Pathology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_PITUITARY_PATHOLOGY,
    },
    {
      id: "pituitary_pharmacology",
      name: "Pituitary - Pharmacology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_PITUITARY_PHARMACOLOGY,
    },
    {
      id: "adrenal_embryology_and_anatomy",
      name: "Adrenal - Embryology and Anatomy",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_ADRENAL_EMBRYOLOGY_AND_ANATOMY,
    },
    {
      id: "adrenal_physiology",
      name: "Adrenal - Physiology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_ADRENAL_PHYSIOLOGY,
    },
    {
      id: "adrenal_pathology",
      name: "Adrenal - Pathology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_ADRENAL_PATHOLOGY,
    },
    {
      id: "adrenal_pharmacology",
      name: "Adrenal - Pharmacology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_ADRENAL_PHARMACOLOGY,
    },
    {
      id: "pancreas_embryology_and_anatomy",
      name: "Pancreas - Embryology and Anatomy",
      url: process.env
        .REACT_APP_STEP1_ENDOCRINE_PANCREAS_EMBRYOLOGY_AND_ANATOMY,
    },
    {
      id: "pancreas_physiology",
      name: "Pancreas - Physiology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_PANCREAS_PHYSIOLOGY,
    },
    {
      id: "pancreas_pathology",
      name: "Pancreas - Pathology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_PANCREAS_PATHOLOGY,
    },
    {
      id: "pancreas_pharmacology",
      name: "Pancreas - Pharmacology",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_PANCREAS_PHARMACOLOGY,
    },
    {
      id: "parathyroid_and_calcium_physiology",
      name: "Parathyroid and Calcium - Physiology",
      url: process.env
        .REACT_APP_STEP1_ENDOCRINE_PARATHYROID_AND_CALCIUM_PHYSIOLOGY,
    },
    {
      id: "parathyroid_and_calcium_pathology",
      name: "Parathyroid and Calcium - Pathology",
      url: process.env
        .REACT_APP_STEP1_ENDOCRINE_PARATHYROID_AND_CALCIUM_PATHOLOGY,
    },
    {
      id: "parathyroid_and_calcium_pharmacology",
      name: "Parathyroid and Calcium - Pharmacology",
      url: process.env
        .REACT_APP_STEP1_ENDOCRINE_PARATHYROID_AND_CALCIUM_PHARMACOLOGY,
    },
    {
      id: "appetite_regulation",
      name: "Appetite Regulation",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_APPETITE_REGULATION,
    },
    {
      id: "signal_transduction_pathways",
      name: "Signal Transduction Pathways",
      url: process.env.REACT_APP_STEP1_ENDOCRINE_SIGNAL_TRANSDUCTION_PATHWAYS,
    },
  ],

  // # GIT topics
  gastrointestinal: [
    {
      id: "embryology",
      name: "Embryology",
      url: process.env.REACT_APP_STEP1_GIT_EMBRYOLOGY,
    },
    {
      id: "anatomy",
      name: "Anatomy",
      url: process.env.REACT_APP_STEP1_GIT_ANATOMY,
    },
    {
      id: "physiology",
      name: "Physiology",
      url: process.env.REACT_APP_STEP1_GIT_PHYSIOLOGY,
    },
    {
      id: "oral_pathology",
      name: "Oral Pathology",
      url: process.env.REACT_APP_STEP1_GIT_ORAL_PATHOLOGY,
    },
    {
      id: "esophageal_pathology",
      name: "Esophageal Pathology",
      url: process.env.REACT_APP_STEP1_GIT_ESOPHAGEAL_PATHOLOGY,
    },
    {
      id: "gastric_pathology",
      name: "Gastric Pathology",
      url: process.env.REACT_APP_STEP1_GIT_GASTRIC_PATHOLOGY,
    },
    {
      id: "intestinal_pathology",
      name: "Intestinal Pathology",
      url: process.env.REACT_APP_STEP1_GIT_INTESTINAL_PATHOLOGY,
    },
    {
      id: "colon_pathology",
      name: "Colon Pathology",
      url: process.env.REACT_APP_STEP1_GIT_COLON_PATHOLOGY,
    },
    {
      id: "intestinal_ischemia_and_bowel_obstruction",
      name: "Intestinal Ischemia & Bowel Obstruction",
      url: process.env
        .REACT_APP_STEP1_GIT_INTESTINAL_ISCHEMIA_AND_BOWEL_OBSTRUCTION,
    },
    {
      id: "hepatic_pathology",
      name: "Hepatic Pathology",
      url: process.env.REACT_APP_STEP1_GIT_HEPATIC_PATHOLOGY,
    },
    {
      id: "biliary_and_pancreatic_pathology",
      name: "Biliary & Pancreatic Pathology",
      url: process.env.REACT_APP_STEP1_GIT_BILIARY_AND_PANCREATIC_PATHOLOGY,
    },
    {
      id: "hernia",
      name: "Hernia",
      url: process.env.REACT_APP_STEP1_GIT_HERNIA,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_GIT_PHARMACOLOGY,
    },
  ],

  // # Dermatology topics
  dermatology: [
    {
      id: "basics_of_dermatology",
      name: "Basics of Dermatology",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_BASICS_OF_DERMATOLOGY,
    },
    {
      id: "pigment_disorders",
      name: "Pigment Disorders",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_PIGMENT_DISORDERS,
    },
    {
      id: "vascular_tumors",
      name: "Vascular Tumors",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_VASCULAR_TUMORS,
    },
    {
      id: "benign_skin_disorders",
      name: "Benign Skin Disorders",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_BENIGN_SKIN_DISORDERS,
    },
    {
      id: "inflammatory_conditions",
      name: "Inflammatory Conditions",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_INFLAMMATORY_CONDITIONS,
    },
    {
      id: "skin_infections",
      name: "Skin Infections",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_SKIN_INFECTIONS,
    },
    {
      id: "blistering_disorders_and_burns",
      name: "Blistering Disorders & Burns",
      url: process.env
        .REACT_APP_STEP1_DERMATOLOGY_BLISTERING_DISORDERS_AND_BURNS,
    },
    {
      id: "cutaneous_ulcers",
      name: "Cutaneous Ulcers",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_CUTANEOUS_ULCERS,
    },
    {
      id: "hair_disorders",
      name: "Hair Disorders",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_HAIR_DISORDERS,
    },
    {
      id: "skin_cancer",
      name: "Skin Cancer",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_SKIN_CANCER,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_DERMATOLOGY_PHARMACOLOGY,
    },
  ],

  // # Neurology topics
  neurology: [
    {
      id: "embryology",
      name: "Embryology",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_EMBRYOLOGY,
    },
    {
      id: "histology",
      name: "Histology",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_HISTOLOGY,
    },
    {
      id: "neuroanatomy",
      name: "Neuroanatomy",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_NEUROANATOMY,
    },
    {
      id: "physiology",
      name: "Physiology",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_PHYSIOLOGY,
    },
    {
      id: "stroke_and_hemorrhage",
      name: "Stroke & Hemorrhage",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_STROKE_AND_HEMORRHAGE,
    },
    {
      id: "seizures_and_headaches",
      name: "Seizures & Headaches",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_SEIZURES_AND_HEADACHES,
    },
    {
      id: "movement_disorders",
      name: "Movement Disorders",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_MOVEMENT_DISORDERS,
    },
    {
      id: "cognitive_decline",
      name: "Cognitive Decline",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_COGNITIVE_DECLINE,
    },
    {
      id: "hydrocephalus_and_intracranial_htn",
      name: "Hydrocephalus & Intracranial HTN",
      url: process.env
        .REACT_APP_STEP1_NEUROLOGY_HYDROCEPHALUS_AND_INTRACRANIAL_HTN,
    },
    {
      id: "neuropathic_and_demyelinating_diseases",
      name: "Neuropathic & Demyelinating Diseases",
      url: process.env
        .REACT_APP_STEP1_NEUROLOGY_NEUROPATHIC_AND_DEMYELINATING_DISEASES,
    },
    {
      id: "brain_tumors_and_neurocutaneous_disorders",
      name: "Brain Tumors & Neurocutaneous Disorders",
      url: process.env
        .REACT_APP_STEP1_NEUROLOGY_BRAIN_TUMORS_AND_NEUROCUTANEOUS_DISORDERS,
    },
    {
      id: "traumatic_brain_injury",
      name: "Traumatic Brain Injury",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_TRAUMATIC_BRAIN_INJURY,
    },
    {
      id: "spinal_diseases",
      name: "Spinal Diseases",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_SPINAL_DISEASES,
    },
    {
      id: "brain_infections",
      name: "Brain Infections",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_BRAIN_INFECTIONS,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_PHARMACOLOGY,
    },
    {
      id: "localization",
      name: "Localization",
      url: process.env.REACT_APP_STEP1_NEUROLOGY_LOCALIZATION,
    },
  ],

  // # Psychiatry topics
  psychiatry: [
    {
      id: "psychology",
      name: "Psychology",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_PSYCHOLOGY,
    },
    {
      id: "childhood_disorders",
      name: "Childhood Disorders",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_CHILDHOOD_DISORDERS,
    },
    {
      id: "orientation_disorders",
      name: "Orientation Disorders",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_ORIENTATION_DISORDERS,
    },
    {
      id: "psychotic_disorders",
      name: "Psychotic Disorders",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_PSYCHOTIC_DISORDERS,
    },
    {
      id: "mood_disorders",
      name: "Mood Disorders",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_MOOD_DISORDERS,
    },
    {
      id: "anxiety_disorders_trauma_and_stress_related_disorders",
      name: "Anxiety, Trauma & Stress Related Disorders",
      url: process.env
        .REACT_APP_STEP1_PSYCHIATRY_ANXIETY_DISORDERS_TRAUMA_AND_STRESS_RELATED_DISORDERS,
    },
    {
      id: "personality_disorders",
      name: "Personality Disorders",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_PERSONALITY_DISORDERS,
    },
    {
      id: "factitious_and_somatic_disorders",
      name: "Factitious & Somatic Disorders",
      url: process.env
        .REACT_APP_STEP1_PSYCHIATRY_FACTITIOUS_AND_SOMATIC_DISORDERS,
    },
    {
      id: "eating_disorders",
      name: "Eating Disorders",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_EATING_DISORDERS,
    },
    {
      id: "sleep_and_sexual_disorders",
      name: "Sleep & Sexual Disorders",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_SLEEP_AND_SEXUAL_DISORDERS,
    },
    {
      id: "substance_abuse",
      name: "Substance Abuse",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_SUBSTANCE_ABUSE,
    },
    {
      id: "psychiatric_emergencies",
      name: "Psychiatric Emergencies",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_PSYCHIATRIC_EMERGENCIES,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_PSYCHIATRY_PHARMACOLOGY,
    },
  ],

  // # Renal topics
  renal: [
    {
      id: "embryology",
      name: "Embryology",
      url: process.env.REACT_APP_STEP1_RENAL_EMBRYOLOGY,
    },
    {
      id: "anatomy",
      name: "Anatomy",
      url: process.env.REACT_APP_STEP1_RENAL_ANATOMY,
    },
    {
      id: "physiology",
      name: "Physiology",
      url: process.env.REACT_APP_STEP1_RENAL_PHYSIOLOGY,
    },
    {
      id: "basics_of_renal_pathology",
      name: "Basics of Renal Pathology",
      url: process.env.REACT_APP_STEP1_RENAL_BASICS_OF_RENAL_PATHOLOGY,
    },
    {
      id: "glomerulonephritis",
      name: "Glomerulonephritis",
      url: process.env.REACT_APP_STEP1_RENAL_GLOMERULONEPHRITIS,
    },
    {
      id: "urinary_incontinence_and_retention",
      name: "Urinary Incontinence & Retention",
      url: process.env.REACT_APP_STEP1_RENAL_URINARY_INCONTINENCE_AND_RETENTION,
    },
    {
      id: "kidney_stones_and_uti",
      name: "Kidney Stones & UTI",
      url: process.env.REACT_APP_STEP1_RENAL_KIDNEY_STONES_AND_UTI,
    },
    {
      id: "renal_failure",
      name: "Renal Failure",
      url: process.env.REACT_APP_STEP1_RENAL_RENAL_FAILURE,
    },
    {
      id: "cysts_and_renovascular_disease",
      name: "Cysts & Renovascular Disease",
      url: process.env.REACT_APP_STEP1_RENAL_CYSTS_AND_RENOVASCULAR_DISEASE,
    },
    {
      id: "renal_tumors",
      name: "Renal Tumors",
      url: process.env.REACT_APP_STEP1_RENAL_RENAL_TUMORS,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_RENAL_PHARMACOLOGY,
    },
  ],

  // # Rapid Review topics
  rapid_review: [
    {
      id: "pathophysiology_of_important_diseases",
      name: "Pathophysiology of Important Diseases",
      url: process.env
        .REACT_APP_STEP1_RAPID_REVIEW_PATHOPHYSIOLOGY_OF_IMPORTANT_DISEASES,
    },
    {
      id: "classical_presentations",
      name: "Classical Presentations",
      url: process.env.REACT_APP_STEP1_RAPID_REVIEW_CLASSICAL_PRESENTATIONS,
    },
    {
      id: "classic_lab_findings",
      name: "Classic Lab Findings",
      url: process.env.REACT_APP_STEP1_RAPID_REVIEW_CLASSIC_LAB_FINDINGS,
    },
    {
      id: "key_associations",
      name: "Key Associations",
      url: process.env.REACT_APP_STEP1_RAPID_REVIEW_KEY_ASSOCIATIONS,
    },
    {
      id: "high_yield_risk_factors",
      name: "High-Yield Risk Factors",
      url: process.env.REACT_APP_STEP1_RAPID_REVIEW_HIGH_YIELD_RISK_FACTORS,
    },
  ],

  // # Chapters with no topics yet - Empty arrays
  microbiology: [
    {
      id: "basic_bacteriology",
      name: "Basic Bacteriology",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_BASIC_BACTERIOLOGY,
    },
    {
      id: "gram_positive_bacteria",
      name: "Gram Positive Bacteria",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_GRAM_POSITIVE_BACTERIA,
    },
    {
      id: "gram_negative_bacteria",
      name: "Gram Negative Bacteria",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_GRAM_NEGATIVE_BACTERIA,
    },
    {
      id: "atypical_gram_staining_bacteria",
      name: "Atypical Gram Staining Bacteria",
      url: process.env
        .REACT_APP_STEP1_MICROBIOLOGY_ATYPICAL_GRAM_STAINING_BACTERIA,
    },
    {
      id: "fungi",
      name: "Fungi",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_FUNGI,
    },
    {
      id: "parasitology",
      name: "Parasitology",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_PARASITOLOGY,
    },
    {
      id: "basic_virology",
      name: "Basic Virology",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_BASIC_VIROLOGY,
    },
    {
      id: "dna_viruses",
      name: "DNA Viruses",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_DNA_VIRUSES,
    },
    {
      id: "rna_viruses",
      name: "RNA Viruses",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_RNA_VIRUSES,
    },
    {
      id: "viral_hepatitis",
      name: "Viral Hepatitis",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_VIRAL_HEPATITIS,
    },
    {
      id: "hiv",
      name: "HIV",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_HIV,
    },
    {
      id: "prions",
      name: "Prions",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_PRIONS,
    },
    {
      id: "systemic",
      name: "Systemic Microbiology",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_SYSTEMIC,
    },
    {
      id: "antibiotics",
      name: "Antibiotics",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_ANTIBIOTICS,
    },
    {
      id: "anti_tb_antibiotics",
      name: "Anti-TB Antibiotics",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_ANTI_TB_ANTIBIOTICS,
    },
    {
      id: "antifungals_and_antiparasitics",
      name: "Antifungals & Antiparasitics",
      url: process.env
        .REACT_APP_STEP1_MICROBIOLOGY_ANTIFUNGALS_AND_ANTIPARASITICS,
    },
    {
      id: "antivirals",
      name: "Antivirals",
      url: process.env.REACT_APP_STEP1_MICROBIOLOGY_ANTIVIRALS,
    },
  ],

  general_pathology: [
    {
      id: "basics",
      name: "Basics",
      url: process.env.REACT_APP_STEP1_GENERAL_PATHOLOGY_BASICS,
    },
    {
      id: "inflammation",
      name: "Inflammation",
      url: process.env.REACT_APP_STEP1_GENERAL_PATHOLOGY_INFLAMMATION,
    },
    {
      id: "neoplasia",
      name: "Neoplasia",
      url: process.env.REACT_APP_STEP1_GENERAL_PATHOLOGY_NEOPLASIA,
    },
    {
      id: "aging",
      name: "Aging",
      url: process.env.REACT_APP_STEP1_GENERAL_PATHOLOGY_AGING,
    },
  ],
  hematology_and_oncology: [
    {
      id: "basics",
      name: "Basics",
      url: process.env.REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_BASICS,
    },
    {
      id: "blood_groups",
      name: "Blood Groups",
      url: process.env.REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_BLOOD_GROUPS,
    },
    {
      id: "bleeding_disorders",
      name: "Bleeding Disorders",
      url: process.env
        .REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_BLEEDING_DISORDERS,
    },
    {
      id: "rbc_disorders",
      name: "RBC Disorders",
      url: process.env.REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_RBC_DISORDERS,
    },
    {
      id: "leukemia",
      name: "Leukemia",
      url: process.env.REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_LEUKEMIA,
    },
    {
      id: "lymphoma",
      name: "Lymphoma",
      url: process.env.REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_LYMPHOMA,
    },
    {
      id: "plasma_cell_disorders",
      name: "Plasma Cell Disorders",
      url: process.env
        .REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_PLASMA_CELL_DISORDERS,
    },
    {
      id: "anti_bleeding_drugs",
      name: "Anti-Bleeding Drugs",
      url: process.env
        .REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_ANTI_BLEEDING_DRUGS,
    },
    {
      id: "anti_cancer_drugs",
      name: "Anti-Cancer Drugs",
      url: process.env
        .REACT_APP_STEP1_HEMATOLOGY_AND_ONCOLOGY_ANTI_CANCER_DRUGS,
    },
  ],
  special_senses: [
    {
      id: "eye_structure",
      name: "Eye Structure",
      url: process.env.REACT_APP_STEP1_SPECIAL_SENSES_EYE_STRUCTURE,
    },
    {
      id: "neuro-ophthalmology",
      name: "Neuro-Ophthalmology",
      url: process.env.REACT_APP_STEP1_SPECIAL_SENSES_NEURO_OPHTHALMOLOGY,
    },
    {
      id: "ear",
      name: "Ear",
      url: process.env.REACT_APP_STEP1_SPECIAL_SENSES_EAR,
    },
    {
      id: "nose_and_throat",
      name: "Nose & Throat",
      url: process.env.REACT_APP_STEP1_SPECIAL_SENSES_NOSE_AND_THROAT,
    },
  ],
  respiratory: [
    {
      id: "embryology",
      name: "Embryology",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_EMBRYOLOGY,
    },
    {
      id: "anatomy",
      name: "Anatomy",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_ANATOMY,
    },
    {
      id: "physiology",
      name: "Physiology",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_PHYSIOLOGY,
    },
    {
      id: "obstructive_diseases",
      name: "Obstructive Diseases",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_OBSTRUCTIVE_DISEASES,
    },
    {
      id: "restrictive_diseases",
      name: "Restrictive Diseases",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_RESTRICTIVE_DISEASES,
    },
    {
      id: "sleep_apnea",
      name: "Sleep Apnea",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_SLEEP_APNEA,
    },
    {
      id: "pleural_diseases",
      name: "Pleural Diseases",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_PLEURAL_DISEASES,
    },
    {
      id: "pulmonary_infections",
      name: "Pulmonary Infections",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_PULMONARY_INFECTIONS,
    },
    {
      id: "lung_cancer",
      name: "Lung Cancer",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_LUNG_CANCER,
    },
    {
      id: "dvt_pe",
      name: "DVT & PE",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_DVT_PE,
    },
    {
      id: "physical_exam",
      name: "Physical Exam",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_PHYSICAL_EXAM,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_RESPIRATORY_PHARMACOLOGY,
    },
  ],
  cardiovascular: [
    {
      id: "embryology",
      name: "Embryology",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_EMBRYOLOGY,
    },
    {
      id: "anatomy",
      name: "Anatomy",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_ANATOMY,
    },
    {
      id: "cardiac_physiology",
      name: "Cardiac Physiology",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_CARDIAC_PHYSIOLOGY,
    },
    {
      id: "vascular_physiology",
      name: "Vascular Physiology",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_VASCULAR_PHYSIOLOGY,
    },
    {
      id: "congenital_heart_diseases",
      name: "Congenital Heart Diseases",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_CONGENITAL_HEART_DISEASES,
    },
    {
      id: "coronary_artery_disease",
      name: "Coronary Artery Disease",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_CORONARY_ARTERY_DISEASE,
    },
    {
      id: "valvular_heart_diseases",
      name: "Valvular Heart Diseases",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_VALVULAR_HEART_DISEASES,
    },
    {
      id: "vascular_diseases",
      name: "Vascular Diseases",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_VASCULAR_DISEASES,
    },
    {
      id: "arrhythmia",
      name: "Arrhythmia",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_ARRHYTHMIA,
    },
    {
      id: "cardiomyopathies",
      name: "Cardiomyopathies",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_CARDIOMYOPATHIES,
    },
    {
      id: "heart_failure",
      name: "Heart Failure",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_HEART_FAILURE,
    },
    {
      id: "infectious_conditions",
      name: "Infectious Cardiac Conditions",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_INFECTIOUS_CONDITIONS,
    },
    {
      id: "pericardial_diseases",
      name: "Pericardial Diseases",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_PERICARDIAL_DISEASES,
    },
    {
      id: "sepsis_shock_syncope",
      name: "Sepsis, Shock & Syncope",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_SEPSIS_SHOCK_SYNCOPE,
    },
    {
      id: "cardiac_tumors",
      name: "Cardiac Tumors",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_CARDIAC_TUMORS,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_CARDIOVASCULAR_PHARMACOLOGY,
    },
  ],
  musculoskeletal_and_connective_tissue: [
    {
      id: "upper_limb_anatomy",
      name: "Upper Limb Anatomy",
      url: process.env.REACT_APP_STEP1_MSK_UPPER_LIMB_ANATOMY,
    },
    {
      id: "lower_limb_anatomy",
      name: "Lower Limb Anatomy",
      url: process.env.REACT_APP_STEP1_MSK_LOWER_LIMB_ANATOMY,
    },
    {
      id: "back_and_vertebral_anatomy",
      name: "Back & Vertebral Anatomy",
      url: process.env.REACT_APP_STEP1_MSK_BACK_AND_VERTEBRAL_ANATOMY,
    },
    {
      id: "physiology",
      name: "Physiology",
      url: process.env.REACT_APP_STEP1_MSK_PHYSIOLOGY,
    },
    {
      id: "common_conditions",
      name: "Common MSK Conditions",
      url: process.env.REACT_APP_STEP1_MSK_COMMON_CONDITIONS,
    },
    {
      id: "childhood_disorders",
      name: "Childhood MSK Disorders",
      url: process.env.REACT_APP_STEP1_MSK_CHILDHOOD_DISORDERS,
    },
    {
      id: "skeletal_disorders",
      name: "Skeletal Disorders",
      url: process.env.REACT_APP_STEP1_MSK_SKELETAL_DISORDERS,
    },
    {
      id: "joint_disorders",
      name: "Joint Disorders",
      url: process.env.REACT_APP_STEP1_MSK_JOINT_DISORDERS,
    },
    {
      id: "muscular_disorders",
      name: "Muscular Disorders",
      url: process.env.REACT_APP_STEP1_MSK_MUSCULAR_DISORDERS,
    },
    {
      id: "autoimmune_and_vasculitis",
      name: "Autoimmune & Vasculitis",
      url: process.env.REACT_APP_STEP1_MSK_AUTOIMMUNE_AND_VASCULITIS,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_MSK_PHARMACOLOGY,
    },
  ],
  reproductive: [
    {
      id: "embryology",
      name: "Embryology",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_EMBRYOLOGY,
    },
    {
      id: "anatomy",
      name: "Anatomy",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_ANATOMY,
    },
    {
      id: "physiology",
      name: "Physiology",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_PHYSIOLOGY,
    },
    {
      id: "sex_disorders",
      name: "Sex Disorders",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_SEX_DISORDERS,
    },
    {
      id: "pregnancy_disorders",
      name: "Pregnancy Disorders",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_PREGNANCY_DISORDERS,
    },
    {
      id: "female_pathology",
      name: "Pathology of Female Reproductive System",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_FEMALE_PATHOLOGY,
    },
    {
      id: "breast_disorders",
      name: "Breast Disorders",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_BREAST_DISORDERS,
    },
    {
      id: "male_pathology",
      name: "Pathology of Male Reproductive System",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_MALE_PATHOLOGY,
    },
    {
      id: "genital_infections",
      name: "Genital Infections",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_GENITAL_INFECTIONS,
    },
    {
      id: "pharmacology",
      name: "Pharmacology",
      url: process.env.REACT_APP_STEP1_REPRODUCTIVE_PHARMACOLOGY,
    },
  ],
  quality_healthcare_delivery: [
    {
      id: "quality",
      name: "Quality",
      url: process.env.REACT_APP_STEP1_QUALITY_AND_HEALTH_CARE_DELIVERY_QUALITY,
    },
    {
      id: "health_care_delivery",
      name: "Health Care Delivery",
      url: process.env
        .REACT_APP_STEP1_QUALITY_AND_HEALTH_CARE_DELIVERY_HEALTH_CARE_DELIVERY,
    },
  ],
  biostatistics_and_epidemiology: [
    {
      id: "study_types",
      name: "Study Types",
      url: process.env
        .REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_STUDY_TYPES,
    },
    {
      id: "bias_and_study_errors",
      name: "Bias and Study Errors",
      url: process.env
        .REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_BIAS_AND_STUDY_ERRORS,
    },
    {
      id: "causality",
      name: "Causality",
      url: process.env.REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_CAUSALITY,
    },
    {
      id: "population_health",
      name: "Population Health",
      url: process.env
        .REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_POPULATION_HEALTH,
    },
    {
      id: "statistics",
      name: "Statistics",
      url: process.env
        .REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_STATISTICS,
    },
    {
      id: "quantifying_risk",
      name: "Quantifying Risk",
      url: process.env
        .REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_QUANTIFYING_RISK,
    },
    {
      id: "diagnostic_tests",
      name: "Diagnostic Tests",
      url: process.env
        .REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_DIAGNOSTIC_TESTS,
    },
    {
      id: "data_visualization",
      name: "Data Visualization",
      url: process.env
        .REACT_APP_STEP1_BIOSTATISTICS_AND_EPIDEMIOLOGY_DATA_VISUALIZATION,
    },
  ],

  ethics_and_communication_skills: [
    {
      id: "general_ethics",
      name: "General Ethics",
      url: process.env
        .REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_SKILLS_GENERAL_ETHICS,
    },
    {
      id: "forensic_medicine",
      name: "Forensic Medicine",
      url: process.env
        .REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_SKILLS_FORENSIC_MEDICINE,
    },
    {
      id: "communication_skills",
      name: "Communication Skills",
      url: process.env
        .REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_SKILLS_COMMUNICATION_SKILLS,
    },
    {
      id: "special_situations",
      name: "Special Situations",
      url: process.env
        .REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_SKILLS_SPECIAL_SITUATIONS,
    },
    {
      id: "ethical_case_scenarios",
      name: "Ethical Case Scenarios",
      url: process.env
        .REACT_APP_STEP1_ETHICS_AND_COMMUNICATION_SKILLS_ETHICAL_CASE_SCENARIOS,
    },
  ],
};
